import {Vue} from "ui.vue";
import {formatFileSize, isDefinedGlobally} from './utils';

const config_messages = Vue.getFilteredPhrases("FIELD_FILE_ERROR_");

const messages = {
	_default: (field) => config_messages.FIELD_FILE_ERROR__default.replace('#field#', field),
	after: (field, [target, inclusion]) => config_messages.FIELD_FILE_ERROR_after.replace('#field#', field) + (inclusion) ? config_messages.FIELD_FILE_ERROR_inclusion : '' + target,
	alpha: (field) => config_messages.FIELD_FILE_ERROR_alpha.replace('#field#', field),
	alpha_dash: (field) => config_messages.FIELD_FILE_ERROR_alpha_dash.replace('#field#', field),
	alpha_num: (field) => config_messages.FIELD_FILE_ERROR_alpha_num.replace('#field#', field),
	alpha_spaces: (field) => config_messages.FIELD_FILE_ERROR_alpha_spaces.replace('#field#', field),
	before: (field, [target, inclusion]) => config_messages.FIELD_FILE_ERROR_before.replace('#field#', field) + (inclusion) ? config_messages.FIELD_FILE_ERROR_inclusion : '' + target,
	between: (field, [min, max]) => config_messages.FIELD_FILE_ERROR_between.replace('#field#', field) + min + config_messages.FIELD_FILE_ERROR_and + max,
	confirmed: (field, [confirmedField]) => config_messages.FIELD_FILE_ERROR_confirmed.replace('#field#', field) + confirmedField,
	credit_card: (field) => config_messages.FIELD_FILE_ERROR_credit_card.replace('#field#', field),
	date_between: (field, [min, max]) => config_messages.FIELD_FILE_ERROR_between.replace('#field#', field) + min + config_messages.FIELD_FILE_ERROR_and + max,
	date_format: (field, [format]) => config_messages.FIELD_FILE_ERROR_date_format.replace('#field#', field) + format,
	decimal: (field, [decimals = '*'] = []) => config_messages.FIELD_FILE_ERROR_decimal.replace('#field#', field) + (decimals === '*') ? '' : decimals + config_messages.FIELD_FILE_ERROR_decimals,
	digits: (field, [length]) => config_messages.FIELD_FILE_ERROR_digits.replace('#field#', field).replace('#length#', length),
	dimensions: (field, [width, height]) => config_messages.FIELD_FILE_ERROR_dimensions.replace('#field#', field).replace('#width#', width).replace('#height#', height),
	email: (field) => config_messages.FIELD_FILE_ERROR_email.replace('#field#', field),
	excluded: (field) => config_messages.FIELD_FILE_ERROR_excluded.replace('#field#', field),
	ext: (field, [...args]) => config_messages.FIELD_FILE_ERROR_ext.replace('#field#', field) + args + ')',
	image: (field) => config_messages.FIELD_FILE_ERROR_image.replace('#field#', field),
	included: (field) => config_messages.FIELD_FILE_ERROR_included.replace('#field#', field),
	integer: (field) => config_messages.FIELD_FILE_ERROR_integer.replace('#field#', field),
	ip: (field) => config_messages.FIELD_FILE_ERROR_ip.replace('#field#', field),
	length: (field, [length, max]) => {
		if (max) {
			return config_messages.FIELD_FILE_ERROR_length_max.replace('#field#', field).replace('#length#', length).replace('#max#', max);
		}
		return config_messages.FIELD_FILE_ERROR_length.replace('#field#', field).replace('#length#', length);
	},
	max: (field, [length]) => config_messages.FIELD_FILE_ERROR_max.replace('#field#', field).replace('#length#', length),
	max_value: (field, [max]) => config_messages.FIELD_FILE_ERROR_max_value.replace('#field#', field).replace('#max#', max),
	mimes: (field, [...args]) => config_messages.FIELD_FILE_ERROR_max_mimes.replace('#field#', field).replace('#args#', args),
	min: (field, [length]) => config_messages.FIELD_FILE_ERROR_min.replace('#field#', field).replace('#length#', length),
	min_value: (field, [min]) => config_messages.FIELD_FILE_ERROR_min_value.replace('#field#', field).replace('#min#', min),
	numeric: (field) => config_messages.FIELD_FILE_ERROR_numeric.replace('#field#', field),
	regex: (field) => config_messages.FIELD_FILE_ERROR_regex.replace('#field#', field),
	required: (field) => config_messages.FIELD_FILE_ERROR_required.replace('#field#', field),
	size: (field, [size]) => config_messages.FIELD_FILE_ERROR_size.replace('#field#', field) + formatFileSize(size),
	url: (field) => config_messages.FIELD_FILE_ERROR_url.replace('#field#', field),
};

const locale = {
	name: 'ru',
	messages,
	attributes: {}
};

if (isDefinedGlobally()) {
	// eslint-disable-next-line
	VeeValidate.Validator.localize({[locale.name]: locale});
}

export default locale;
